<template>
    <div class="py-24 flex justify-center bg-white">
        <div class="w-auto flex justify-center flex-wrap">
            <img src="@/assets/images/accounting/no-file.svg" class="mr-1"/>
        <p class="w-full py-4">Imported data will appear here...</p>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>